import AddIcon from "@mui/icons-material/Add";
import { Box, Fab } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addFormPermissionsForRole, deleteFormPermissionsForRole, editFormPermissionsForRole, getFormPermissionsByRole } from "../../../../actions/forms";
import snackbarUtils from "../../../../utils/snackbarUtils";
import ConfirmDeleteDialog from "../../../commons/dialog/confirmDeleteDialog";
import ArtFormSearchFormContainer from "./artFormSearchFormContainer";
import FormConfigurationFormContainer from "./formConfiguration/formConfigurationFormContainer";
import ArtFormsConfigurationTable from "./table/artFormsConfigurationTable";



const ArtFormsConfigurationContainer = () => {
  const dispatch = useDispatch();
  const [openForm, setOpenForm] = useState(false);
  const [formToEdit, setFormToEdit] = useState(null);

  const [openDelete, setOpenDelete] = useState(false);
  const [formToDelete, setFormToDelete] = useState(null);

  const loadingEditForm = useSelector((state) => state.forms.editFormPermissionsForRole.isFetching);
  const loadingAddForm = useSelector((state) => state.forms.addFormPermissionsForRole.isFetching);
  const loadingDeleteForm = useSelector((state) => state.forms.deleteFormPermissionsForRole.isFetching);
  const handleOpenForm = (formConfiguration) => {
    setOpenForm(true);
    setFormToEdit(formConfiguration);
  }

  const handleCloseForm = () => {
    setOpenForm(false);
    setFormToEdit(null);
  }

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setFormToDelete(null);
  }

  const handleDelete = () => {
    const body = {
      idArt: formToDelete.idArt,
      idRol: formToDelete.idRol,
      idFormulario: formToDelete.idFormulario,
    }
    dispatch(deleteFormPermissionsForRole(body)).then(() => {
      dispatch(getFormPermissionsByRole(body.idArt))
      snackbarUtils.success("Se ha eliminado el formulario correctamente.");
      handleCloseDelete();
    });
  }

  const handleSubmitForm = (values) => {
    const body = {
      permisosFormularios: {
        ver: values.ver,
        crear: values.crear,
        editar: values.editar,
        borrar: values.borrar,
        idFormulario: values.idFormulario,
      },
      idRol: values.idRol,
      idArt: values.idArt,
    }
    if (formToEdit) {
      dispatch(editFormPermissionsForRole(body, !formToEdit?.parent)).then(() => {
        dispatch(getFormPermissionsByRole(body.idArt))
        handleCloseForm();
        snackbarUtils.success("Se han guardado los cambios correctamente.");
      })
    } else {
      dispatch(addFormPermissionsForRole(body)).then(() => {
        dispatch(getFormPermissionsByRole(body.idArt))
        handleCloseForm();
        snackbarUtils.success("Se ha agregado el formulario correctamente.");
      })
    }
  }

  return (
    <>
      <ArtFormSearchFormContainer />
      <ArtFormsConfigurationTable
        handleEdit={handleOpenForm}
        handleDelete={(values) => { setOpenDelete(true); setFormToDelete(values) }}
      />
      {
        <Box
          sx={{
            margin: "5px 20px",
            display: "flex",
            justifyContent: "flex-end",
          }}>
          <Fab
            onClick={() => handleOpenForm()}
            color="primary"
            aria-label="add">
            <AddIcon />
          </Fab>
        </Box>
      }
      <ConfirmDeleteDialog
        open={openDelete}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        title="Confirmar eliminación"
        loading={loadingDeleteForm}
        text={`¿Estás seguro de que deseas eliminar el permiso del formulario "${formToDelete?.formulario}" para el rol "${formToDelete?.tipo}"? Esta acción no se puede deshacer.`}
      />
      <FormConfigurationFormContainer
        open={openForm}
        formConfigurationToEdit={formToEdit}
        handleClose={handleCloseForm}
        editingRole={formToEdit && !formToEdit?.parent}
        loading={loadingEditForm || loadingAddForm}
        handleSubmit={handleSubmitForm}
      />
    </>

  )
}

export default ArtFormsConfigurationContainer;